import React, { createContext, useContext, useState } from "react";
import { ToastType } from "../components/common/toast-notification";

interface ToastContextType {
  showToast: boolean;
  toastMessage: string;
  toastType: ToastType;
  setShowToast: (show: boolean) => void;
  showSuccessToast: (message: string) => void;
  showErrorToast: (message: string) => void;
  showInfoToast: (message: string) => void;
}

const ToastContext = createContext<ToastContextType | undefined>(undefined);

export function ToastProvider({ children }: { children: React.ReactNode }) {
  const [showToast, setShowToast] = useState(false);
  const [toastType, setToastType] = useState<ToastType>("info");
  const [toastMessage, setToastMessage] = useState("");

  const showSuccessToast = (message: string) => {
    setToastType("success");
    setToastMessage(message);
    setShowToast(true);
  };

  const showErrorToast = (message: string) => {
    setToastType("error");
    setToastMessage(message);
    setShowToast(true);
  };

  const showInfoToast = (message: string) => {
    setToastType("info");
    setToastMessage(message);
    setShowToast(true);
  };

  return (
    <ToastContext.Provider
      value={{
        showToast,
        toastMessage,
        toastType,
        setShowToast,
        showSuccessToast,
        showErrorToast,
        showInfoToast,
      }}
    >
      {children}
    </ToastContext.Provider>
  );
}

export function useToast() {
  const context = useContext(ToastContext);
  if (context === undefined) {
    throw new Error("useToast must be used within a ToastProvider");
  }
  return context;
}
